<template>
  <ChipsField
    id="mealplan-multiple-terminal-id"
    name="config.terminal_id"
    :label="t('sites.singleSite.financialConfig.mealPlans.form.multipleTerminalId')"
    :placeholder="
      t('sites.singleSite.financialConfig.mealPlans.form.multipleTerminalIdPlaceholder')
    "
    :addOnBlur="true"
    :disabled="!editMealPlan"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../../routes';

const { t } = useI18n();

const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);
</script>
